"use client";

import { usePathname } from "next/navigation";
import { useMemo } from "react";

const BASE_PATHS = ["services", "back-office"] as const;

type BasePath = (typeof BASE_PATHS)[number];

export const useBasePath = (): BasePath | null => {
  const pathname = usePathname();

  return useMemo(() => {
    const firstSegment = pathname.split("/").find((segment) => segment !== "");
    if (firstSegment == null) {
      return null;
    }
    const match = BASE_PATHS.find((bp) => bp === firstSegment);
    return match ?? null;
  }, [pathname]);
};
